"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.OverlayDefaultContent = void 0;
require("./OverlayDefaultContent.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _OverlayDefaultFooter = _interopRequireDefault(require("../OverlayDefaultFooter/OverlayDefaultFooter"));
var _OverlayDefaultHeader = _interopRequireDefault(require("../OverlayDefaultHeader/OverlayDefaultHeader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * OverlayDefaultContent component
 *
 * @method
 * @param { OverlayDefaultContentProps } props
 * @returns OverlayDefaultContent
 */

const OverlayDefaultContent = props => {
  const {
    children,
    description,
    externalCloseActionElement,
    externalFooterChildrenElements,
    externalBackActionElement,
    showCloseButton = defaultProps.showCloseButton,
    showBackButton = defaultProps.showBackButton,
    showHeaderDivider,
    showFooterDivider,
    title,
    titleSize,
    titleTag,
    supportText
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-OverlayDefaultContent', {});
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, /*#__PURE__*/_react.default.createElement(_OverlayDefaultHeader.default, {
    title: title,
    description: description,
    showBackButton: showBackButton,
    showCloseButton: showCloseButton,
    showHeaderDivider: showHeaderDivider,
    externalBackActionElement: externalBackActionElement,
    externalCloseActionElement: externalCloseActionElement,
    titleSize: titleSize,
    titleTag: titleTag
  }), children && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-OverlayDefaultContent__content"
  }, children), /*#__PURE__*/_react.default.createElement(_OverlayDefaultFooter.default, {
    externalFooterChildrenElements: externalFooterChildrenElements,
    showFooterDivider: showFooterDivider,
    supportText: supportText
  }));
};

/**
 * Property type definitions
 * @typedef OverlayDefaultContentProps
 * @type {object}
 * @property {string} title - The title of the sticky header.
 * @property {string} description - The description of the sticky header.
 * @property {object} externalCloseActionElement - Close button element on header passed from web-site with additional business and data capture logic.
 * @property {object} externalFooterChildrenElements - ActionGroupDefault for footer from web-site with additional logic.
 * @property {object} externalBackActionElement - Back button element on header passed from web-site with additional business and data capture logic.
 * @property {boolean} showBackButton - Flag to show back button.
 * @property {boolean} showCloseButton - Flag to show close button.
 * @property {boolean} showHeaderDivider - Flag to show divider on header.
 * @property {boolean} showFooterDivider - Flag to show divider on footer.
 * @property {node} children - The content to be rendered inside the sticky container.
 * @property {string} titleSize - Size of the title - set to compact to render TitlesDefaultCompact
 * @property {string} supportText - Displays support text below the footer actions.
 * @property {string} titleTag - HTML tag of the title - default set in TitlesDefault
 */
exports.OverlayDefaultContent = OverlayDefaultContent;
const propTypes = exports.propTypes = {
  /**
   * Back button element on header passed from web-site with additional business and data capture logic.
   */
  externalBackActionElement: _propTypes.default.object,
  /**
   * The title of the sticky header.
  */
  title: _propTypes.default.string,
  /**
   * The description of the sticky header.
  */
  description: _propTypes.default.string,
  /**
   * Close button element on header passed from web-site with additional business and data capture logic.
   */
  externalCloseActionElement: _propTypes.default.object,
  /**
   * ActionGroupDefault for footer from web-site with additional logic.
   */
  externalFooterChildrenElements: _propTypes.default.object,
  /**
   * The content to be rendered inside the sticky container.
  */
  children: _propTypes.default.node,
  /**
   * Flag to show back button.
   */
  showBackButton: _propTypes.default.bool,
  /**
   * Flag to show close button.
   */
  showCloseButton: _propTypes.default.bool,
  /**
   * Flag to show dividers on header.
   */
  showHeaderDivider: _propTypes.default.bool,
  /**
   * Flag to show dividers on footer.
   */
  showFooterDivider: _propTypes.default.bool,
  /**
   * Size of the title - set to compact to render TitlesDefaultCompact
   */
  titleSize: _propTypes.default.string,
  /**
   * Displays support text below the footer actions.
   */
  supportText: _propTypes.default.string,
  /**
   * HTML tag of the title - default set in TitlesDefault
   */
  titleTag: _propTypes.default.string
};

/**
 * Default values for passed properties
 * @type {object}
 * @property {boolean} showBackButton - showBackButton: false - sets the default for showBackButton
 * @property {boolean} showCloseButton - showCloseButton: true - sets the default for showCloseButton
 */
const defaultProps = exports.defaultProps = {
  showBackButton: false,
  showCloseButton: true
};
OverlayDefaultContent.propTypes = propTypes;
OverlayDefaultContent.defaultProps = defaultProps;
var _default = exports.default = OverlayDefaultContent;